import { Zap, CheckSquare } from 'lucide-react';

import { ApprovalListView } from './_components/approvals';
import { AutomationEditorView } from './_components/automations/_AutomationEditorView';
import { AutomationListView } from './_components/automations/_AutomationListView';
import { ExecutionRunDetailView } from './_components/executions/_ExecutionRunDetailView';

import { createAppModule } from '~/shared/routing/createAppModule';
import { createModuleNav } from '~/shared/routing/createModuleNav';
import { createModuleRoutes } from '~/shared/routing/createModuleRoutes';

const basePath = '/workflows';
const automationsPath = `${basePath}/automations`;
const approvalsPath = `${basePath}/approvals`;

export const automationsRoutes = createModuleRoutes({
  root: {
    path: basePath,
    label: (t) => t.menu?.automations?.root || 'Workflows',
    icon: Zap,
  },
  list: {
    path: automationsPath,
    label: (t) => t.menu?.automations?.workflows || 'Automations',
    icon: Zap,
    component: AutomationListView,
  },
  create: {
    path: `${automationsPath}/new`,
    component: AutomationEditorView,
  },
  executionDetail: {
    path: `${automationsPath}/:id/executions/:executionId`,
    component: ExecutionRunDetailView,
  },
  detail: {
    path: `${automationsPath}/:id`,
    component: AutomationEditorView,
  },
  approvals: {
    path: approvalsPath,
    label: (t) => t.menu?.automations?.approvals || 'Approvals',
    icon: CheckSquare,
    component: ApprovalListView,
  },
});

const automationsNav = createModuleNav(($) =>
  $(automationsRoutes.root, [
    $(automationsRoutes.list),
    $(automationsRoutes.approvals),
    $(automationsRoutes.create),
    $(automationsRoutes.executionDetail),
    $(automationsRoutes.detail),
  ]),
);

export const automationsModule = createAppModule({
  routes: automationsRoutes,
  nav: automationsNav,
});
